import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'

dayjs.extend(localizedFormat)

export default function formatDate(dateString: string, currentLocale: string, format = 'LL') {
  return dayjs(dateString).locale(currentLocale).format(format)
}
